export default __webpack_public_path__ + "dcb4814.png";